import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpRequest,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';

import { authInterceptor } from './interceptors/auth.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor])),
  ],
};
